import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetDirectMembershipsForFacepileQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  resourceId: Types.Scalars['ID']['input'];
}>;


export type GetDirectMembershipsForFacepileQuery = { __typename?: 'Query', directMemberships?: { __typename?: 'MembershipConnection', totalCount: number, nodes: Array<{ __typename?: 'Membership', id: string, accountUser?: { __typename?: 'AccountUser', avatarColor?: Types.AvatarColor | null, displayName?: string | null, email?: string | null, id: string, inviteEmailAddress?: string | null, name?: string | null, profileImageUrl?: string | null } | null, accountUserGroup?: { __typename?: 'AccountUserGroup', emoji?: string | null, id: string, name?: string | null } | null, userGroup?: { __typename?: 'AdobeManagedUserGroup', emoji?: string | null, id: string, name?: string | null } | { __typename?: 'FrameManagedUserGroup', emoji?: string | null, id: string, name?: string | null } | { __typename?: 'WorkfrontManagedUserGroup', emoji?: string | null, id: string, name?: string | null } | null }> } | null, indirectMembershipsTotalCount?: { __typename?: 'MembershipConnection', totalCount: number } | null, account?: { __typename?: 'Account', id: string, resource?: { __typename?: 'Account', uniqueMemberCount?: number | null, id: string } | { __typename?: 'AudioAsset', uniqueMemberCount?: number | null, id: string } | { __typename?: 'DocumentAsset', uniqueMemberCount?: number | null, id: string } | { __typename?: 'FileAsset', uniqueMemberCount?: number | null, id: string } | { __typename?: 'FolderAsset', uniqueMemberCount?: number | null, id: string } | { __typename?: 'ImageAsset', uniqueMemberCount?: number | null, id: string } | { __typename?: 'InteractiveAsset', uniqueMemberCount?: number | null, id: string } | { __typename?: 'InteractiveLiveAsset', uniqueMemberCount?: number | null, id: string } | { __typename?: 'ModelAsset', uniqueMemberCount?: number | null, id: string } | { __typename?: 'Project', uniqueMemberCount?: number | null, id: string } | { __typename?: 'UnsupportedAsset', uniqueMemberCount?: number | null, id: string } | { __typename?: 'VersionStackAsset', uniqueMemberCount?: number | null, id: string } | { __typename?: 'VideoAsset', uniqueMemberCount?: number | null, id: string } | { __typename?: 'Workspace', uniqueMemberCount?: number | null, id: string } | null } | null };


export const GetDirectMembershipsForFacepile = /*#__PURE__*/ gql`
    query GetDirectMembershipsForFacepile($accountId: ID!, $resourceId: ID!) {
  directMemberships(resourceId: $resourceId, page: {first: 3}) {
    nodes {
      id
      accountUser {
        avatarColor
        displayName @client
        email
        id
        inviteEmailAddress
        name
        profileImageUrl
      }
      accountUserGroup {
        emoji
        id
        name
      }
      userGroup {
        emoji
        id
        name
      }
    }
    totalCount
  }
  indirectMembershipsTotalCount: indirectMemberships(
    resourceId: $resourceId
    page: {first: 0}
  ) {
    totalCount
  }
  account(by: {id: $accountId}) {
    id
    resource(id: $resourceId) {
      uniqueMemberCount
      id
    }
  }
}
    ` as unknown as DocumentNode<GetDirectMembershipsForFacepileQuery, GetDirectMembershipsForFacepileQueryVariables>;

          

          export const useGetDirectMembershipsForFacepileQuery = (options?:QueryHookOptions<GetDirectMembershipsForFacepileQuery, GetDirectMembershipsForFacepileQueryVariables>) => useQuery(GetDirectMembershipsForFacepile, options);

          

          export type GetDirectMembershipsForFacepileQueryOptions = QueryHookOptions<GetDirectMembershipsForFacepileQuery, GetDirectMembershipsForFacepileQueryVariables>;

          

          export const useGetDirectMembershipsForFacepileLazyQuery = (options?:LazyQueryHookOptions<GetDirectMembershipsForFacepileQuery, GetDirectMembershipsForFacepileQueryVariables>) => useLazyQuery(GetDirectMembershipsForFacepile, options);

          

          export type GetDirectMembershipsForFacepileQueryResult = ReturnType<typeof useGetDirectMembershipsForFacepileQuery>;

          
